module.exports = __webpack_public_path__ + "img/defaultimg.3da3b68e.jpg";